import * as tslib_1 from "tslib";
import { NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, ReplaySubject, fromEvent, merge, race, timer } from 'rxjs';
import { filter, map, mergeMap, repeat, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ModalController } from '@ionic/angular';
import { DialogIdleLogoutComponent } from 'src/app/components/custom/dialog-idle-logout/dialog-idle-logout.component';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../auth/auth.service";
import * as i3 from "@ionic/angular";
var defaultIdleTimeMinutes = environment.production ? 15 : 1;
var defaultLogoutTimeMinutes = environment.production ? 25 : 2;
var IdleLogoutService = /** @class */ (function () {
    function IdleLogoutService(router, auth, modalCtrl, _ngZone) {
        var _this = this;
        this.router = router;
        this.auth = auth;
        this.modalCtrl = modalCtrl;
        this._ngZone = _ngZone;
        this.stopped$ = new ReplaySubject(1);
        this.resetIdleTimer$ = new BehaviorSubject(null);
        this.idleCount = 0;
        this.idleCountBeforeLogout = 3;
        this.modalIsOpen = 0;
        // time in milliseconds until modal is opened (set in watch() for kiosk vs normal users)
        this.idleMilliseconds = defaultIdleTimeMinutes * 60000;
        // time in milliseconds, after modal is opened, until user is automatically logged out
        this.logoutMilliseconds = defaultLogoutTimeMinutes * 60000;
        this.idleTimeMinutes = defaultIdleTimeMinutes;
        this.logoutTimeMinutes = defaultLogoutTimeMinutes;
        this.interaction$ = merge(timer(0), this.resetIdleTimer$, fromEvent(window, 'mousemove'), fromEvent(window, 'keydown'), fromEvent(window, 'touchstart'), fromEvent(window, 'blur') // When user switches browser tab
        );
        // timer that resets on user interaction (before modal is opened)
        this.idle$ = this.interaction$.pipe(switchMap(function () { return timer(_this.idleMilliseconds); }));
        // timer that resets on user interaction (after modal is opened)
        this.delayLogout$ = this.interaction$.pipe(switchMap(function () { return timer(_this.logoutMilliseconds); }));
        // observable opens modal and emits when modal is closed or dismissed
        this.modal$ = timer(0).pipe(switchMap(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var modal, _a, data, role;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: DialogIdleLogoutComponent,
                            componentProps: {
                                idleTime: this.idleTimeMinutes,
                                logoutTime: this.logoutTimeMinutes
                            }
                        })];
                    case 1:
                        modal = _b.sent();
                        if (!(this.idleCount >= this.idleCountBeforeLogout)) return [3 /*break*/, 2];
                        debugger;
                        console.log('Idle count limit reached... Logout! iLde Count: ', this.idleCount);
                        this.resetIdleTimer$.next(null);
                        this.idleCount = 0;
                        this.auth.logout();
                        return [3 /*break*/, 4];
                    case 2:
                        // Open the Model
                        modal.present();
                        this.modalIsOpen++;
                        this.idleCount++;
                        return [4 /*yield*/, modal.onWillDismiss()];
                    case 3:
                        _a = _b.sent(), data = _a.data, role = _a.role;
                        debugger;
                        this.resetIdleTimer$.next(null);
                        if (role === 'confirm') {
                            // console.log('The confirm button was clicked. Data: ', data)
                            this.modalIsOpen--;
                            this.idleCount = 0;
                            this.resetIdleTimer$.next(null);
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/, merge(modal.onWillDismiss()).pipe(tap(function () {
                            debugger;
                            _this.modalIsOpen--;
                            _this.resetIdleTimer$.next(null);
                        }))];
                }
            });
        }); }));
        this.idle$.subscribe(function (idle) {
            console.log('idle$ subscription: ', idle);
            console.log('idle$ idleTime: ', _this.idleTimeMinutes, ', idleMilliseconds: ', _this.idleMilliseconds);
            console.log('idle$ logoutTime: ', _this.logoutTimeMinutes, ', logoutMilliseconds:', _this.logoutMilliseconds);
        });
    }
    /**
     * Enables auto logout on a component
     */
    IdleLogoutService.prototype.watch = function () {
        var _this = this;
        var isKiosk = this.auth.hasDepotKioskPermission();
        if (isKiosk) {
            this.idleTimeMinutes = environment.production ? 60 : 30; // 60 or 30 min until warning
            this.logoutTimeMinutes = environment.production ? 120 : 60; // 120 or 60 min until auto logout
        }
        else {
            this.idleTimeMinutes = defaultIdleTimeMinutes;
            this.logoutTimeMinutes = defaultLogoutTimeMinutes;
        }
        this.idleMilliseconds = this.idleTimeMinutes * 60000;
        this.logoutMilliseconds = this.logoutTimeMinutes * 60000;
        this._ngZone.runOutsideAngular(function () {
            _this.idle$.pipe(filter(function () { return !_this.modalIsOpen; }), mergeMap(function () { return race(_this.delayLogout$.pipe(map(function () { return true; })), _this.modal$.pipe(map(function () { return false; }))); }), filter(function (result) { return result; }), take(1), takeUntil(_this.stopped$), repeat())
                .subscribe(function () {
                // Refresh the user's token when the logout timeout is reached (keeps session alive if they come back)
                _this.auth.userRefreshToken().catch(function () { });
                _this.resetIdleTimer();
                // console.log('Logout timeout has been reached.  this.delayLogout$: ',  this.delayLogout$)
                // console.log('Logout timeout has been reached.  this.modal$: ',  this.modal$)
                // console.log('Logout timeout has been reached.  environment:  ',  environment.production);
            });
        });
    };
    /**
     * Call on ngOnDestroy() to prevent behavior from carrying over after component destroyed
     */
    IdleLogoutService.prototype.stop = function () {
        this.stopped$.next(true);
        this.stopped$.complete();
        this.unsubscribeObservable();
        this.idleCount = 0;
    };
    IdleLogoutService.prototype.resetIdleTimer = function () {
        // console.log('resetIdleTimer: ', this.idle$);
        this.resetIdleTimer$.next(null);
    };
    IdleLogoutService.prototype.subscribeObservable = function () {
        this.idleSubscription = this.idle$.subscribe(function (x) {
            console.log("idleSubscription subcribed for " + (x + 1) + " sec");
        });
        this.logoutSubscription = this.delayLogout$.subscribe(function (x) {
            console.log("logoutSubscription subcribed for " + (x + 1) + " sec");
        });
    };
    IdleLogoutService.prototype.unsubscribeObservable = function () {
        console.log('  unsubscriebd');
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
        }
        if (this.logoutSubscription) {
            this.logoutSubscription.unsubscribe();
        }
    };
    IdleLogoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function IdleLogoutService_Factory() { return new IdleLogoutService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.ModalController), i0.ɵɵinject(i0.NgZone)); }, token: IdleLogoutService, providedIn: "root" });
    return IdleLogoutService;
}());
export { IdleLogoutService };
